// --- src/api/users.js ---
import axios from 'axios';
import { getAuth } from 'firebase/auth';

// Create a custom axios instance with credentials enabled
const usersAPI = axios.create({
  baseURL: process.env.REACT_APP_API_URL 
    ? `${process.env.REACT_APP_API_URL}/users`
    : 'http://localhost:5050/api/users',
  withCredentials: true, // Required for cross-origin cookies
});

// Add Firebase token to every request if user is authenticated
usersAPI.interceptors.request.use(async (config) => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (user) {
      const token = await user.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (err) {
    console.warn('⚠️ Failed to attach Firebase token:', err.message);
  }

  return config;
}, (error) => Promise.reject(error));

// Define API methods
export default {
  getProfile: () => usersAPI.get('/profile'),
  updateProfile: (data) => usersAPI.put('/profile', data),
};